import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { AppService } from "src/_services/app.service";
import { Router } from "@angular/router";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatTableDataSource,
} from "@angular/material";
import { FormArray, FormBuilder, FormControl, FormGroup } from "@angular/forms";

@Component({
  selector: "app-catalogue-rules",
  templateUrl: "./catalogue-rules.component.html",
  styleUrls: ["../events-settlements/events-settlements.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CatalogueRulesComponent implements OnInit {
  providers: any = [];
  ProviderId: string = "";
  sportsList = [];
  rulesList = new MatTableDataSource<any>();
  sportId;
  sportName: string = "";

  rulesTableColumns = ["SNo", "StartsWith", "Contains", "EndsWith", "Actions"];
  constructor(
    private appService: AppService,
    private router: Router,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.getOurProviders();
    if (this.ProviderId) {
      this.getSportsByProvider(this.ProviderId);
    }
  }

  onSelectedStatusTab(selectedProvider) {
    this.rulesList.data = [];
    this.ProviderId = selectedProvider;
    this.sportId = "";
    this.getSportsByProvider(this.ProviderId);
  }

  getOurProviders() {
    try {
      this.appService.getOurProviders().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.providers = res.providers;
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) { }
  }

  addRule = () => {
    let dialogRef = this.dialog.open(AddRules, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        title: "Add New Rule",
        add: true,
        providerId: this.ProviderId,
        sportId: this.sportId,
        key: this.rulesList.data.length,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getRules();
      }
    });
  };

  editRule = (element) => {
    let dialogRef = this.dialog.open(AddRules, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        title: "Edit Rule",
        add: false,
        providerId: this.ProviderId,
        sportId: this.sportId,
        start: element.start,
        id: element.id,
        contain: element.contain,
        category: element.category,
        end: element.end,
        append: element.append,
        prepend: element.prepend,
        remove: element.remove,
        replacements: element.replace,
        createdAt: element.createdAt,
        key: 0,
        ruleKey: element.ruleKey,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getRules();
      }
    });
  };

  disableRule() {
    if (this.ProviderId === "" || this.sportId === "") {
      return true;
    }
    return false;
  }

  onSelectedSportName(Sport) {
    this.rulesList.data = [];
    this.sportId = Sport.SportId;
    this.sportName = Sport.SportName;
    this.getRules();
  }

  getSportsByProvider(providerId) {
    try {
      this.appService.getSportData(providerId).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.sportsList = res.sports;
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) { }
  }

  deleteRule(element) {
    try {
      let dialogRef = this.dialog.open(DeleteRuleModal, {
        backdropClass: "backdropBackground",
        hasBackdrop: true,
        data: {
          providerId: this.ProviderId,
          sportId: this.sportId,
          id: element.id,
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.getRules();
        }
      });
    } catch (err) {
      console.log(err);
      this.appService.openErrorBar("invalid");
    }
  }

  getRules() {
    try {
      let filters = {
        providerId: this.ProviderId,
        sportId: this.sportId,
      };
      this.appService.getCatalogueRule(filters).subscribe((response) => {
        if (response.status === "RS_OK") {
          this.rulesList.data = response.rules;
        } else {
          this.appService.openErrorBar(response.errorDescription);
          if (response.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {
      console.log(err);
    }
  }
}

@Component({
  selector: "dialog-overview-example-dialog",
  templateUrl: "./add-rule.html",
  styleUrls: ["./add-rule.scss"],
})
export class AddRules implements OnInit {
  ruleForm: FormGroup;
  categories = ["MATCH", "INNINGS", "OVER", "PLAYER", "HEAD-TO-HEAD", "OTHER"];

  constructor(
    private fb: FormBuilder,
    private appService: AppService,
    public router: Router,
    public dialogRef: MatDialogRef<AddRules>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.ruleForm = this.fb.group({
      start: this.fb.array(this.data.start ? this.data.start : []),
      contain: this.fb.array(this.data.contain ? this.data.contain : []),
      end: [this.data.end || ""],
      category: [this.data.category || "OTHER"],
      replacements: this.fb.array(
        this.data.replacements
          ? this.data.replacements.map((rep) =>
            this.fb.group({
              old: [rep.old],
              new: [rep.new],
            })
          )
          : []
      ),
      remove: [this.data.remove || ""],
      append: [this.data.append || ""],
      prepend: [this.data.prepend || ""],
    });
    // this.addReplacement();
  }

  get replacements() {
    return this.ruleForm.get("replacements") as FormArray;
  }

  addReplacement() {
    // Check if the last replacement entry has an empty 'old' value
    const lastReplacement = this.replacements.at(this.replacements.length - 1);

    if (lastReplacement && !lastReplacement.get("old").value) {
      // If the 'old' value is empty, do not allow adding a new replacement
      return;
    }

    // If the last 'old' value is not empty, allow adding a new replacement
    this.replacements.push(
      this.fb.group({
        old: [""],
        new: [""],
      })
    );
  }

  removeReplacement(index: number) {
    this.replacements.removeAt(index);
  }

  disable() {
    return (
      this.ruleForm.value.start.length === 0 && this.ruleForm.value.end === ""
    );
  }

  inputControl = new FormControl("");
  separatorKeysCodes: number[] = [ENTER, COMMA];

  // Add value to the array
  add(event: any) {
    const input = event.input;
    const value = event.value.trim();

    if (value) {
      this.ruleForm.value.contain.push(value.toLowerCase());
    }

    // Reset the input field
    if (input) {
      input.value = "";
    }
  }

  addStart(event: any) {
    const input = event.input;
    const value = event.value.trim();

    if (value) {
      this.ruleForm.value.start.push(value.toLowerCase());
    }

    // Reset the input field
    if (input) {
      input.value = "";
    }
  }

  // Remove value from the array
  remove(value) {
    const index = this.ruleForm.value.contain.indexOf(value);
    if (index >= 0) {
      this.ruleForm.value.contain.splice(index, 1);
    }
  }

  removeStart(value) {
    const index = this.ruleForm.value.start.indexOf(value);
    if (index >= 0) {
      this.ruleForm.value.start.splice(index, 1);
    }
  }

  confirm() {
    if (this.disable()) {
      return;
    }

    const filteredReplacements = this.ruleForm.value.replacements.filter(
      (replacement) => replacement.old && replacement.old.trim() !== ""
    );

    const payload = {
      id: this.data.id || "",
      key: this.data.key + 1,
      providerId: this.data.providerId,
      sportId: this.data.sportId,
      start: this.ruleForm.value.start,
      contain: this.ruleForm.value.contain,
      category: this.ruleForm.value.category,
      ruleKey: this.data.ruleKey,
      end: this.ruleForm.value.end,
      replace: filteredReplacements,
      append: this.ruleForm.value.append,
      prepend: this.ruleForm.value.prepend,
      remove: this.ruleForm.value.remove,
      createdAt: this.data.createdAt,
    };

    if (this.data.add) {
      this.appService.addCatalogueRule(payload).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.appService.openSuccessBar(res.errorDescription);
          this.dialogRef.close(true);
        } else {
          this.appService.openErrorBar(res.errorDescription);
          this.dialogRef.close();
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } else {
      this.appService.editCatalogueRule(payload).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.appService.openSuccessBar(res.errorDescription);
          this.dialogRef.close(true);
        } else {
          this.appService.openErrorBar(res.errorDescription);
          this.dialogRef.close();
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: "dialog-overview-example-dialog",
  templateUrl: "./delete-rule.html",
  styleUrls: ["./add-rule.scss"],
})
export class DeleteRuleModal {
  constructor(
    private appService: AppService,
    public router: Router,
    public dialogRef: MatDialogRef<DeleteRuleModal>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  confirm() {
    try {
      let filters = {
        providerId: this.data.providerId,
        sportId: this.data.sportId,
        id: this.data.id,
      };
      this.appService.deleteCatalogueRule(filters).subscribe((res) => {
        this.dialogRef.close(true);
        if (res.status === "RS_OK") {
          this.appService.openSuccessBar(res.errorDescription);
        } else {
          this.appService.openErrorBar(res.errorDescription);
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {
      console.log(err);
      this.appService.openErrorBar(err);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
